import "../Style.css/App.css";
import Content from "./Content";

function App() {
  return (
    <div className="App">
      <Content />
    </div>
  );
}

export default App;
